/**
 * Saved Search Observability Constants
 *
 * These constants define the event names tracked for saved search observability.
 * Used with NewRelic Browser APM for monitoring saved search flows.
 */

/**
 * Event tracked when saved search creation fails
 */
export const SAVED_SEARCH_CREATE_FAILURE = 'saved_search_create_failure' as const;

/**
 * Event tracked when saved search deletion fails
 */
export const SAVED_SEARCH_DELETE_FAILURE = 'saved_search_delete_failure' as const;

/**
 * Event tracked when saved search update fails
 */
export const SAVED_SEARCH_UPDATE_FAILURE = 'saved_search_update_failure' as const;
